/* eslint-disable react-hooks/exhaustive-deps */
import { DialogContent } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import consultaApi from '../../../services/consultaApi';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import CircularProgress from '@material-ui/core/CircularProgress';
import CampoTextoAjuda from '../campo-texto-ajuda';
// import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles(theme => ({
    tituloModal: {
        color: "#01518e",
        textAlign: "center",
    },
    codigo: {
        marginTop: 0,
        borderRadius: '4px 0px 0px 4px'
    },
    descricaoSemCodigo: {
        marginBottom: 8,
        borderRadius: '4px 0px 0px 4px'
    },
    descricao: {
        marginBottom: 8,
        borderRadius: 0
    },
    botaoPesquisa: {
        height: 56,
        borderRadius: '0px 4px 4px 0px',
        display: 'flex',
        alignItems: 'center',
        minWidth: '100%',
        padding: 0,
        justifyContent: 'center',
        backgroundColor: '#cdcdcd'
    },
    controlaItemLista: {
        backgroundColor: '#f1f1f1',
        borderRadius: 4,
        marginBottom: 5
    },
    controlaFechar: {
        position: 'relative',
        left: '30%'
    }
}))

export default function BuscaForm(props) {
    const { tabela,
        label,
        procedureConsulta,
        setDescricao,
        descricao,
        codigo,
        setCodigoPai,
        inativo = false,
        ocultaCodigo = false,
        consultaInstantanea = false,
        tipo,
        ajuda } = props;

    const classes = useStyles();

    const [open, setOpen] = useState(false);
    const [filtro] = useState(props.filtro ? props.filtro : '');
    const [valorPesquisa, setValorPesquisa] = useState('');
    const [resultados, setResultados] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        consultaInstantanea && pesquisar()
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const trazInfo = (resultado) => {
        setCodigoPai(resultado[Object.keys(resultado)[0]]);
        setDescricao(resultado[Object.keys(resultado)[1]]);
        setOpen(false);
    }

    async function consultaBanco() {
        setLoading(true);
        let dadosEnvio = {
            MODIFICACAO: -1,
            FILTRO: filtro,
            VALORPESQUISA: valorPesquisa,
            PROCNAME: procedureConsulta,
        }


        const resposta = await consultaApi(dadosEnvio)

        let respostaDados;
        respostaDados = resposta.data.DATASET;

        setLoading(false)

        if (respostaDados) {
            return Object.values(resposta.data.DATASET)
        } else {
            return [{ CCDUNID: "", CDSUNID: "Não foram encontrado dados." }]
        }

    }

    async function pesquisar() {
        let retornoFunction = await consultaBanco();
        setResultados(retornoFunction);
    }

    async function buscaDescricao() {
        let dadosEnvio = {
            MODIFICACAO: -1,
            ID: codigo,
            PROCNAME: 'WEBSITE_DESCBYID',
            TABELA: tabela
        }
        let retornoDescricao;

        const retorno = await consultaApi(dadosEnvio);
        if (retorno.data.DATASET) {
            retornoDescricao = retorno.data.DATASET[0].DESCRICAO;
        }

        if (retornoDescricao) {
            setDescricao(retornoDescricao);
        } else {
            setDescricao('')
        }
    }

    // const Transition = React.forwardRef(function Transition(props, ref) {
    //     return <Slide direction="up" ref={ref} {...props} />;
    // });

    return (
        <>
            <Grid container>
                {!ocultaCodigo &&
                    <Grid item xs={3}>
                        <TextField
                            margin="normal"
                            variant="outlined"
                            error={props.erro}
                            type={tipo ? tipo : "number"}
                            disabled={inativo}
                            className={classes.codigo}
                            fullWidth
                            value={codigo}
                            onChange={e => setCodigoPai(e.target.value)}
                            onBlur={buscaDescricao}
                            InputProps={{
                                className: classes.codigo
                            }}
                        />
                    </Grid>
                }
                <Grid item xs={ocultaCodigo ? 10 : 7}>
                    {ajuda ? <CampoTextoAjuda
                        disabled
                        buscaForm
                        className={ocultaCodigo ? classes.descricaoSemCodigo : classes.descricao}
                        label={label}
                        error={props.erro}
                        helperText={props.erro ? props.erroTexto : ''}
                        value={descricao}
                        onChange={setDescricao}
                        tituloAjuda={ajuda.tituloAjuda}
                        textoAjuda={ajuda.textoAjuda}
                        saibaMais={ajuda.saibaMais}
                        obrigatorio={ajuda.obrigatorio}
                    /> : <TextField
                        fullWidth
                        label={label}
                        variant="outlined"
                        className={ocultaCodigo ? classes.descricaoSemCodigo : classes.descricao}
                        error={props.erro}
                        helperText={props.erro ? props.erroTexto : ''}
                        value={descricao}
                        disabled
                        InputProps={{
                            className: ocultaCodigo ? classes.descricaoSemCodigo : classes.descricao
                        }}
                    />}


                </Grid>
                <Grid item xs={2}>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={handleClickOpen}
                        disabled={inativo}
                        disableElevation
                        className={classes.botaoPesquisa}
                    >
                        <SearchIcon color="primary" />
                    </Button>
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="Busca Externa"
                    // TransitionComponent={Transition}
                    fullScreen
                    fullWidth
                >
                    <DialogTitle id="busca-form-titulo" className={classes.tituloModal}>
                        {props.label}
                        <IconButton onClick={handleClose} className={classes.controlaFechar}>
                            <CloseRoundedIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            id="Buscar"
                            label="Buscar..."
                            placeholder="Descrição"
                            fullWidth
                            variant="outlined"
                            value={valorPesquisa}
                            onChange={e => setValorPesquisa(e.target.value)}
                        />
                        <List>

                            {!loading ? resultados.map(resultado => (
                                <ListItem
                                    button
                                    className={classes.controlaItemLista}
                                    key={resultado[Object.keys(resultado)[0]]}
                                    onClick={() => trazInfo(resultado)}
                                >
                                    <ListItemText
                                        primary={resultado[Object.keys(resultado)[1]]}
                                        secondary={resultado[Object.keys(resultado)[0]]}
                                    />
                                </ListItem>
                            )) : <CircularProgress />}
                        </List>
                    </DialogContent>
                    <DialogActions style={{ alignItems: "center" }}>
                        <Button
                            variant="filled"
                            color="primary"
                            onClick={pesquisar}
                        >
                            Buscar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </>
    )
}